<h1 mat-dialog-title>
	{{ title }}
</h1>
<div mat-dialog-content>
	<p>	{{ text }}</p>
	<form [formGroup]="form">
		<mat-form-field class="full-width">
      <mat-label>{{ 'offline-flags.offline-flag.contextOriginCode' | translate }}</mat-label>
			<mat-select id="contextOriginCode" formControlName="contextOriginCode">
				<mat-option *ngFor="let context of availableContexts" [value]="context.originCode">
					{{ context.originCode }}
				</mat-option>
			</mat-select>
			<mat-error *ngIf="form.controls.contextOriginCode.hasError('required')">
				{{ "commons.form.errors.required" | translate }}
			</mat-error>
		</mat-form-field>
	</form>
</div>
<div mat-dialog-actions style="justify-content: flex-end; display: flex;">
	<button mat-raised-button color="warn" (click)="onCancelClick()">
		{{ cancelBtnText | translate }}
	</button>
	<button mat-raised-button color="primary" (click)="onOkClick()">
		{{ okBtnText | translate }}
	</button>
</div>
